// extracted by mini-css-extract-plugin
module.exports = {"button":"register-button_button__aLUre","icon":"register-button_icon__NjKTz"};